import classNames from 'classnames';
import { Link } from 'gatsby';
import React, { use } from 'react';

import { SiteContext } from 'src/context/site-context';
import { getBuildDomainForBuildType } from 'src/enums/build/build-domain';
import type { ClubInformation } from 'src/enums/club-information';
import { clubNameDependingOnBuildTypeAndLanguage } from 'src/helpers/club-helper';
import { getAbsoluteClubPagePath, getClubPagePath } from 'src/helpers/navigation-helper';

import Location from '../../icons/location';

import * as styles from './club-search-link.module.scss';

type ClubSearchLinkProps = {
  className?: string;
  club: ClubInformation;
  isOpen?: boolean;
  onClick?: () => void;
};

export const ClubSearchLink = ({ className, club, isOpen, onClick }: ClubSearchLinkProps) => {
  const { language, buildType } = use(SiteContext);
  const clubName = clubNameDependingOnBuildTypeAndLanguage(club.clubName, buildType, language);
  const linkClassName = classNames(styles.link, isOpen === true && styles.open, className);

  return getBuildDomainForBuildType(club.buildType) === getBuildDomainForBuildType(buildType) ? (
    <Link
      to={getClubPagePath('', club.siteId, language)}
      className={linkClassName}
      onClick={onClick}
    >
      <Location />
      {clubName}
    </Link>
  ) : (
    <a
      href={getAbsoluteClubPagePath('', club.siteId, language)}
      className={linkClassName}
      onClick={onClick}
    >
      <Location />
      {clubName}
    </a>
  );
};
